import styled from "styled-components";

export const AlbumsWrapper = styled.div`
  width: 100%;
  /* background-color: aliceblue; */
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  .createAlbumWrapper {
    height: 200px;
    width: 200px;
    background-color: 272727;
    border: 3px solid #e85a4f;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 10px 15px;
    color: #14a76c;
    font-weight: 700;
    .createAlbumBtn {
      background-color: inherit;
      text-align: center;
      font-size: 4rem;
      width: min-content;
      height: min-content;
    }
  }
`;
